export default "__VITE_ASSET__BvqYmBqP__"